import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { LangProvider } from './lib/lang';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RaffleDetailPage from './pages/RaffleDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import WalletPage from './pages/WalletPage';
import AccountPage from './pages/AccountPage';
import WinnersPage from './pages/WinnersPage';
import VipPage from './pages/VipPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminRaffles from './pages/admin/AdminRaffles';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPacks from './pages/admin/AdminPacks';
import AdminSettings from './pages/admin/AdminSettings';
import AdminPromos from './pages/admin/AdminPromos';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminBanners from './pages/admin/AdminBanners';
import AdminChat from './pages/admin/AdminChat';
import AdminVipPlans from './pages/admin/AdminVipPlans';
import AdminSpinWheel from './pages/admin/AdminSpinWheel';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminBackup from './pages/admin/AdminBackup';
import AdminWinners from './pages/admin/AdminWinners';
import AdminLegalPages from './pages/admin/AdminLegalPages';
import AdminTextOverrides from './pages/admin/AdminTextOverrides';
import AdminPayments from './pages/admin/AdminPayments';
import AdminSales from './pages/admin/AdminSales';
import AdminWhatsAppContacts from './pages/admin/AdminWhatsAppContacts';
import AdminCryptoPayments from './pages/admin/AdminCryptoPayments';
import AdminClientErrors from './pages/admin/AdminClientErrors';
import AdminVisitors from './pages/admin/AdminVisitors';
import DiagnosticPage from './pages/DiagnosticPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LegalPage from './pages/LegalPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import CryptoPaymentPage from './pages/CryptoPaymentPage';
import MagicLoginPage from './pages/MagicLoginPage';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import SpinWheel from './components/SpinWheel';
import ChatWidget from './components/ChatWidget';
import AgeVerification from './components/AgeVerification';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppBadge from './components/WhatsAppBadge';
import ErrorBoundary from './components/ErrorBoundary';
import VisitorTracker from './components/VisitorTracker';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <VisitorTracker />
            <div className="min-h-screen bg-background text-foreground">
              <Header />
              <ErrorBoundary>
                <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/raffle/:id" element={<RaffleDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/account" element={<AccountPage />} />
            <Route path="/winners" element={<WinnersPage />} />
            <Route path="/vip" element={<VipPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/raffles" element={<AdminRaffles />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/packs" element={<AdminPacks />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/promos" element={<AdminPromos />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/banners" element={<AdminBanners />} />
            <Route path="/admin/chat" element={<AdminChat />} />
            <Route path="/admin/vip" element={<AdminVipPlans />} />
            <Route path="/admin/spin" element={<AdminSpinWheel />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/backup" element={<AdminBackup />} />
            <Route path="/admin/winners" element={<AdminWinners />} />
            <Route path="/admin/legal-pages" element={<AdminLegalPages />} />
            <Route path="/admin/text-overrides" element={<AdminTextOverrides />} />
            <Route path="/admin/payments" element={<AdminPayments />} />
            <Route path="/admin/crypto" element={<AdminCryptoPayments />} />
            <Route path="/admin/client-errors" element={<AdminClientErrors />} />
            <Route path="/admin/visitors" element={<AdminVisitors />} />
            <Route path="/admin/sales" element={<AdminSales />} />
            <Route path="/admin/whatsapp-contacts" element={<AdminWhatsAppContacts />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/payment/crypto" element={<CryptoPaymentPage />} />
            <Route path="/magic/:token" element={<MagicLoginPage />} />
            <Route path="/auth/google" element={<GoogleCallbackPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/terms" element={<LegalPage defaultSlug="terms" />} />
            <Route path="/privacy" element={<LegalPage defaultSlug="privacy" />} />
            <Route path="/cookies" element={<LegalPage defaultSlug="cookies" />} />
            <Route path="/responsible-play" element={<LegalPage defaultSlug="responsible-play" />} />
            </Routes>
              </ErrorBoundary>
            <Toaster richColors position="top-right" />
            <AgeVerification />
            <SpinWheel />
            <ChatWidget />
            <WhatsAppBadge />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
    </ErrorBoundary>
  );
}

export default App;
